import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import Header from '../../components/Header/Header';
import RecoverPasswordForm from '../../components/Forms/RecoverPasswordForm/RecoverPasswordForm';

import settings from '../../settings/settings';

import './RecoverPassword.scss';

function RecoverPassword() {
  const { showErrorMessage } = useContext(UIContext);
  const { redefinePassword } = useContext(AuthContext);

  const navigate = useNavigate();

  const logoURL = `${settings.BASE_PATH_IMAGES_FOLDER}/logo-vc-agente-web.svg`;

  async function handleSubmit({ email, code, password }, { setSubmitting }) {
    const opResRedefinePass = await redefinePassword({ email, code, password });

    if (!opResRedefinePass.success) {
      showErrorMessage({
        message: opResRedefinePass.msg
      });
      return;
    };
    setSubmitting(false);
    navigate('/login');
  }

  return (
    <div className="outter-page recover-password-page">
      <div className="outter-page-content-container">
        <Header showBackBtn />
        <div className="form-container">
          <img src={logoURL} className="App-logo-sm" alt="logo" />
          <RecoverPasswordForm
            onSubmit={handleSubmit} />
        </div>
      </div>
    </div>
  );
}

export default RecoverPassword;
